import { noop, get } from 'lodash/fp';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { createGeneratorMiddleware } from 'redux-action-generators';

import { trackingMiddleware } from 'helpers/tracking';
import createApiMiddleware from './middlewares/createApiMiddleware';
import createRouteHelper from './createRouteHelper';
import getMatched from '../components/App/Routes/getMatched';
import { createEmptyCarLeadHashLoggerMiddleware } from './middlewares/createEmptyHashLoggerMiddleware';
import { logError, ERROR_TYPES } from '../helpers/wkda-logger';

export default ({
  api,
  cookies,
  dataLayer,
  handleError,
  history,
  initMatchedRoute,
  initialState,
  reducer,
  referer,
  userAgent,
  location,
  setServerResponseStatus = noop,
}) => {
  const asyncReducers = {};
  const injectReducer = (asyncReducer) => {
    const key = asyncReducer.key;

    if (asyncReducers[key]) {
      return;
    }

    asyncReducers[key] = asyncReducer;

    store.replaceReducer(reducer(initialState, asyncReducers, history)); // eslint-disable-line no-use-before-define
  };

  let currentLocation = history.location;
  const getCurrentLocation = () => currentLocation;
  const setCurrentLocation = (location) => {
    currentLocation = location;
  };
  const getRouteParams = (location) =>
    get(['match', 'params'], getMatched(location.pathname)) || {};

  const log = (error) => {
    return logError({
      type: ERROR_TYPES.server,
      error,
      referrer:
        typeof window !== 'undefined' ? window.location.href : undefined,
    });
  };

  const middlewares = [
    createRouterMiddleware(history),
    createEmptyCarLeadHashLoggerMiddleware(log),
    createApiMiddleware({ api }),
    trackingMiddleware(dataLayer),
    createGeneratorMiddleware(
      {
        cookies,
        getCurrentLocation,
        setCurrentLocation,
        referer,
        userAgent,
        location,
        routeParams: getRouteParams(location),
        setServerResponseStatus,
        injectReducer,
        history,
        routeHelpers: createRouteHelper({
          history,
          initMatchedRoute,
          setCurrentLocation,
        }),
      },
      handleError,
    ),
  ];

  const store = createStore(
    reducer(initialState, undefined, history),
    initialState,
    compose(
      applyMiddleware(...middlewares),

      global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
        : (f) => f,
    ),
  );

  store.setCurrentLocation = setCurrentLocation;
  store.getCurrentLocation = getCurrentLocation;

  return store;
};
